import { useAppSelector } from '@/shared/lib/redux/hooks';
import { useListMembershipsQuery } from '../api/authApi';

/** The signed-in user's own membership row for `store.currentStoreId` — role/status for the
 *  admin panel's permission checks. */
export function useCurrentMembership() {
  const currentStoreId = useAppSelector((state) => state.store.currentStoreId);
  const { data: memberships } = useListMembershipsQuery();
  return memberships?.find((m) => m.storeId === currentStoreId);
}

/** `true` for OWNER — the only role, allowed to mutate catalog/pricing data. */
export function useCanManageCatalog(): boolean {
  return useCurrentMembership()?.role === 'OWNER';
}

/** Same rule as `useCanManageCatalog` (OWNER is the only role); kept under this name for its
 *  other call sites. */
export function useIsOwnerOrAdmin(): boolean {
  return useCurrentMembership()?.role === 'OWNER';
}
